import { FC } from 'react';
import styles from './../../index.module.scss';
import classNames from 'classnames';
interface Params {
  children?: any;
  bold?: boolean;
}
export const Paragraph: FC<Params> = (props) => {
  return (
    <div className={classNames(props.bold ? styles.bold : '')}>
      {props.children}
    </div>
  );
};
